import { Component, Input, OnInit } from '@angular/core';
import { NiveauObligation, TracabiliteArticle } from '@lexi-clients/lexi';

@Component({
    selector: 'app-tracabilite-article',
    templateUrl: './tracabilite-article.component.html',
    styleUrls: ['./tracabilite-article.component.scss'],
    standalone: false
})
export class TracabiliteArticleComponent implements OnInit {

  @Input() tracabilite : TracabiliteArticle;
  @Input() isModificationEnCours : boolean;

  niveauObligations = [
    { id : NiveauObligation.obligatoire, libelle : 'Obligatoire'},
    { id : NiveauObligation.facultatif, libelle : 'Facultatif'},
    { id : NiveauObligation.desactive, libelle : 'Desactivé'},
  ];
  constructor() { }

  ngOnInit() {
   }
}
